import { HardDrive } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import MyButton from '../buttons'

interface StorageFullModalProps {
  isOpen: boolean
  onClose: () => void
  totalSize: number
  maxSize: number
  remainingSize: number
}

const StorageFullModal = ({
  isOpen,
  onClose,
  totalSize,
  maxSize,
  remainingSize,
}: StorageFullModalProps) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  const usagePercentage = Math.min((totalSize / maxSize) * 100, 100)

  return (
    <div className='fixed inset-0 bg-black/30 flex items-center justify-center p-4 z-50'>
      <div className='bg-white rounded-lg p-6 max-w-md w-full'>
        <div className='flex flex-col items-center text-center'>
          <div className='relative mb-4'>
            <HardDrive className='w-16 h-16 text-redpink' />
          </div>

          <h3 className='text-xl font-bold text-gray-900 mb-2'>
            {t('storage-full-title')}
          </h3>

          <p className='text-gray-600 mb-4'>
            {t('storage-full-message', {
              currentSize: totalSize.toFixed(2),
              maxSize: maxSize,
              remainingSize: remainingSize.toFixed(2),
            })}
          </p>

          <div className='w-full bg-gray-200 rounded-full h-2.5 mb-4'>
            <div
              className='h-2.5 rounded-full bg-redpink transition-all duration-300'
              style={{ width: `${usagePercentage}%` }}
            />
          </div>

          <div className='bg-redlight p-4 rounded-lg mb-6 w-full'>
            <p className='text-sm text-redpink'>
              {t('storage-full-suggestion')}
            </p>
          </div>

          <MyButton onClick={onClose} variant='redpink-anthracite'>
            {t('understood')}
          </MyButton>
        </div>
      </div>
    </div>
  )
}

export default StorageFullModal
